module.exports = __webpack_public_path__ + "img/baoxian.b35868bd.png";